
import {isEmptyOrNil} from '@ultradent/utilities/EmptyOrNil';
import {mapRootUrl} from '@util/URLUtils';
import {dropMenuNav} from '../../styles';
import DropMenu from '../';
import Menu from '../../Menu';

const Nav = ( {menuItems = []} ) =>
    <nav className={dropMenuNav.root}>
        <ul className={dropMenuNav.list}>
            {menuItems
                .map( ( {secondaryImage, ...item} ) => {
                    // note -> use backgroundImage if secondaryImage.source provided, else will fallback image declared in navigation.css
                    const menuStyle = secondaryImage?.source
                        ? {backgroundImage: `url(${secondaryImage?.source})`}
                        : null;

                    return (
                        <DropMenu.navItem {...item}>
                            {!isEmptyOrNil( item.children ) &&
                                <Menu style={menuStyle} menuItems={item.children.map( mapRootUrl( item ) )}/>
                            }
                        </DropMenu.navItem>
                    )
                } )}
        </ul>
    </nav>;

export default Nav;